import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { getAgentTournamentEndDate } from './tournamentDates';

const useCountdown = () => {
  const tournamentEndDate = getAgentTournamentEndDate();
  const countDownDate = tournamentEndDate
    ? dayjs(tournamentEndDate).toDate().getTime()
    : dayjs()
        .add(1, 'month')
        .startOf('month')
        .subtract(-3, 'hour')
        .subtract(1, 'day')
        .toDate()
        .getTime();

  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = countDown => {
  const totalSeconds = Math.max(Math.floor(countDown / 1000), 0);
  const days = Math.floor(totalSeconds / (60 * 60 * 24));
  const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
  const seconds = totalSeconds % 60;
  const time = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');

  return { date: `${days} days ${time}` };
};

export { useCountdown };
